import { render, staticRenderFns } from "./ValidatePin.vue?vue&type=template&id=70fcdc43&scoped=true"
import script from "./ValidatePin.vue?vue&type=script&lang=js"
export * from "./ValidatePin.vue?vue&type=script&lang=js"
import style0 from "./ValidatePin.vue?vue&type=style&index=0&id=70fcdc43&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fcdc43",
  null
  
)

export default component.exports